export enum SeoPageType {
  Home = 0,
  Product = 1,
}

export enum RequestLanguage {
  EN = "EN_US",
  ZH = "ZH_CN",
}
